import styled from 'styled-components'

const GamesCardStyle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 0.25rem;
  border: 2px solid rgba(255, 250, 250, 0.15);
  width: 25vw;
  min-width: 32rem;
  min-height: 30rem;
  z-index: 1;
  border-radius: 8px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.15) 0%,
    rgba(0, 0, 0, 0.45) 100%
  );
  transition: all 1s ease;
  aspect-ratio: 4/3;

  margin: 1rem;
  padding: 1.5rem;
  flex-shrink: 0;

  ${
    '' /* a {
    color: ${(props) => props.theme.primary};
    margin-right: 1rem;

    &:hover {
      transition: all 1s ease;
      color: ${(props) => props.theme.secondary};
    }
  } */
  }

  img {
    border-radius: 0.25rem;
    border: 2px solid rgba(255, 250, 250, 0.15);
  }

  &:hover {
    border: 2px solid rgba(255, 250, 250, 0.5);
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.25) 0%,
      rgba(0, 0, 0, 0.65) 100%
    );
    h4 {
      transition: all 1s ease;
      color: ${(props) => props.theme.primary};
    }
  }

  @media (max-width: 968px) {
    min-width: 20rem;
    width: 80%;
    aspect-ratio: auto;
    flex-direction: column;
    ${'' /* min-height: 60vw; */}
  }

  @media (max-width: 768px) {
    width: 92%;
    aspect-ratio: auto;
    ${'' /* min-height: 60vw; */}
  }

  @media (max-width: 361px) {
    width: 90%;
    aspect-ratio: auto;
  }
`

export default GamesCardStyle
